import { Component } from '@angular/core';

@Component({
  selector: 'app-matriz-de-requisitos-legales',
  templateUrl: './matriz-de-requisitos-legales.component.html',
  styleUrls: ['./matriz-de-requisitos-legales.component.css']
})
export class MatrizDeRequisitosLegalesComponent {

}
